export const ENDPOINTS = {
    ATTACHMENTS: 'api/attachments',
    AUTH_TOKEN: 'token',
    CAPABILITIES: 'api/capabilities',
    CMS_TEMPLATES: 'api/cms_templates',
    CMS_TEMPLATES_EXPORT: 'api/cms_templates/export/format',
    COMPANIES: 'api/companies',
    COMPANIES_EXPORT: 'api/companies/export/format',
    COMPANY_ABONO: 'api/companies/abono',
    DISCOUNTS: 'api/discounts',
    DISCOUNTS_EXPORT: 'api/discounts/export/format',
    DISCOUNTS_MASSIVE: 'api/discounts/massive',
    DISCOUNT_CODES: 'api/discount_codes',
    ENCLOSURES: 'api/enclosures',
    ENCLOSURES_EXPORT: 'api/enclosures/export/format',
    ENCLOSURES_PARTIALLY: 'api/enclosures/partially',
    ENCLOSURES_TYPES: 'api/enclosures_types',
    EVENTS: 'api/events',
    EVENTS_EXPORT: 'api/events/export/format',
    EVENTS_PARTIALLY: 'api/events/partially',
    EVENTS_STATUSES: 'api/events/states',
    EVENT_CATEGORIES: 'api/event_categories',
    EVENT_SESSIONS: 'api/events_sessions',
    EVENT_SESSIONS_FINISH_BY_ACTION: 'api/events_sessions_finish_by_action',
    EVENT_SESSIONS_INDIVIDUALS: 'api/events_sessions_individuals',
    EVENT_SESSIONS_INDIVIDUALS_CHANGE_TICKET_CONFIG: 'api/events_sessions_individuals/change-ticket-config',
    EVENT_TYPES: 'api/event_types',
    FILES: 'api/files',
    INCIDENCES_AGENTS: 'api/agents',
    INCIDENCES_CONVERSATIONS: 'api/updates',
    INCIDENCES_STATUSES: 'api/statuses',
    INCIDENCES_TICKETS_EXPORT: 'api/tickets/export',
    INCIDENCES_TICKETS_STATISTICS: 'api/tickets/statistics',
    INCIDENCES_TYPES: 'api/categories',
    MARKETS: 'api/markets',
    NOTIFICATIONS: 'api/notifications',
    NOTIFICATIONS_EXPORT: 'api/notifications/export/format',
    NOTIFICATIONS_RECEIVER_TYPES: 'api/receiver_types',
    OPERATIONS: 'api/operations',
    OPERATIONS_EXPORT: 'api/operations/export/format',
    PROVINCES: 'api/provinces',
    REPORTS: 'api/reports',
    REPORTS_ACTIONS: 'api/reports_actions',
    REPORTS_EXPORT: 'api/reports/export/format',
    REPORTS_TYPES: 'api/reports/types',
    ROLES: 'api/roles',
    SIDEBAR_STATISTICS: 'api/statistics_sidebar',
    SUBSCRIBERS: 'api/subscribers',
    SUBSCRIBERS_EXPORT: 'api/subscribers/export/format',
    SUBSCRIBERS_LEADS: 'api/subscribers-leads',
    SUBSCRIBERS_LEADS_EXPORT: 'api/subscribers-leads/export/format',
    SUBSCRIPTIONS: 'api/subscriptions',
    SUBSCRIPTIONS_EXPORT: 'api/subscriptions/export/format',
    SUBSCRIPTIONS_MASSIVE: 'api/subscriptions/massive',
    SUBSCRIPTIONS_STATISTICS: 'api/subscriptions/statistics',
    SUBSCRIPTION_TYPES: 'api/subscription_types',
    SUBSCRIPTION_TYPES_PARTIALLY: 'api/subscription_types/partially',
    TAXES: 'api/taxs',
    TEMPLATES: 'api/templates',
    TEMPLATES_GENERIC_EMAILS: 'api/templates/generics',
    TEMPLATES_EXPORT: 'api/templates/export/format',
    TEMPLATE_TAGS: 'api/templates/placeholders',
    TICKETS: 'api/tickets',
    TICKET_CODES: 'api/ticket_codes',
    TOWNSHIPS: 'api/townships',
    USERS: 'api/users',
    USERS_EXPORT: 'api/users/export/format',
    USERS_PARTIALLY: 'api/users/partially',
} as const;

export default ENDPOINTS;
export type EndpointKey = keyof typeof ENDPOINTS;
